import { APP_ORIGIN } from "@/lib/api";

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export const STATUS_CHIP = {
  uploaded: { label: "Uploaded", cls: "bg-bg-elevated text-ink-secondary border-line" },
  tagged: { label: "Tagged", cls: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40" },
};

// Internal artwork URLs (/api/rip/art/...) need the app origin; remote URLs pass through.
export const artSrc = (url) => (url && url.startsWith("/api/") ? `${APP_ORIGIN}${url}` : url);

// Reads any browser-decodable image file, normalizes to a JPEG data URL (max 1600px).
export const readImageFile = (file) => new Promise((resolve, reject) => {
  if (!file.type.startsWith("image/")) return reject(new Error("Use a JPG, PNG or WebP image"));
  if (file.size > 10 * 1024 * 1024) return reject(new Error("Image too large (max 10MB)"));
  const url = URL.createObjectURL(file);
  const img = new Image();
  img.onload = () => {
    const scale = Math.min(1, 1600 / Math.max(img.width, img.height));
    const c = document.createElement("canvas");
    c.width = Math.round(img.width * scale);
    c.height = Math.round(img.height * scale);
    c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
    URL.revokeObjectURL(url);
    resolve(c.toDataURL("image/jpeg", 0.92));
  };
  img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("Could not read this image — use JPG, PNG or WebP")); };
  img.src = url;
});

export const rotateImage = (dataUrl) => new Promise((resolve, reject) => {
  const img = new Image();
  img.onload = () => {
    const c = document.createElement("canvas");
    c.width = img.height; c.height = img.width;
    const ctx = c.getContext("2d");
    ctx.translate(c.width / 2, c.height / 2);
    ctx.rotate(Math.PI / 2);
    ctx.drawImage(img, -img.width / 2, -img.height / 2);
    resolve(c.toDataURL("image/jpeg", 0.92));
  };
  img.onerror = () => reject(new Error("Could not rotate this image"));
  img.src = dataUrl;
});

export const cropSquare = (dataUrl) => new Promise((resolve, reject) => {
  const img = new Image();
  img.onload = () => {
    const s = Math.min(img.width, img.height);
    const c = document.createElement("canvas");
    c.width = s; c.height = s;
    c.getContext("2d").drawImage(img, (img.width - s) / 2, (img.height - s) / 2, s, s, 0, 0, s, s);
    resolve(c.toDataURL("image/jpeg", 0.92));
  };
  img.onerror = () => reject(new Error("Could not crop this image"));
  img.src = dataUrl;
});

export const uploadArtwork = async (api, dataUrl, kind = "cover") => {
  const blob = await (await fetch(dataUrl)).blob();
  const fd = new FormData();
  fd.append("file", blob, "artwork.jpg");
  fd.append("kind", kind);
  const r = await api.post("/rip/artwork/upload", fd);
  return r.data;
};
